// Func = limiting Scope for this file
// function resizeWindow(){}
$(function () {

    $(document).ready(function () {

        let smart_widget_open = false;
        $("#smart-booking--trigger-js, #close-booking").click(function () {
            $("#smart-booking__container").fadeToggle();
            if (smart_widget_open) {
                return smart_widget_open = false;
            } else {
                return smart_widget_open = true;
            }
        });
        $(document).keyup(function (e) {
            if (e.keyCode == 27 && smart_widget_open) {
                $("#smart-booking__container").fadeToggle();
                return smart_widget_open = false;
            }
        });

        if (window.matchMedia("(min-device-width : 768px)  and (max-device-width : 1024px)").matches) {
            // Open active sub-nav on load When Active
            $('#primary-nav ul.submenu li .active').parent().parent().slideDown();

            //PREVENTS ITEMS WITH SUBMENU TO GO ON FIRST CLICK
            $("#primary-nav ul > li > a").click(function (e) {
                let submenu = $(this).siblings("ul.submenu");
                $('#primary-nav ul.submenu li .active').parent().parent().removeClass("item-open");
                if (submenu.length > 0) {
                    e.preventDefault()
                    $("#primary-nav ul.submenu").stop().slideUp();
                    submenu.stop().slideDown();
                }
            });

        } else {
            // Main Nav Dropdown
            $("#primary-nav li").hover(function () {
                let submenu = $(this).children("ul.submenu").length > 0;
                if (submenu) {
                    $('ul.submenu', this).stop().fadeIn(200);
                }
            }, function () {
                $('ul.submenu', this).stop().fadeOut(200);
            });
        }

        $('.book-now').on('click', function () {
            if (typeof ga == 'function') ga('send', 'event', 'reservations', 'click', 'book now');
        });
        //this class should be add to the header widget submit button
        $('.bookNow').on('click', function () {
            if (typeof ga == 'function') ga('send', 'event', 'header widget', 'click', 'book now');
        });

        // Map: Return to previous page button. Change body id to match map template's name.
        if (document.querySelector("body#map") !== null || document.querySelector("body#map-category") !== null) {
            const map_buttons = `
                <div class="return-from-map">
                    <a class="btn" href="javascript:history.back()" style="margin-right: 10px">Back to previous page</a>
                    <a class="btn" href="/things-to-do-in-san-antonio/ada-map">View Accessible Map</a>
                </div>
            `;
            $('.content').prepend(map_buttons);
        }


        $("button.button-trigger").click(function (e) {
            let $target = $(this).data("target");
            $(this).toggleClass("active");
            $($target).toggleClass("open");
        });


    });

    $(window).load(function () {

        //Add 0 To slick Dots
        $("#reasons-to-stay ul.slick-dots li button").each(function () {
            let dotsNumber = $(this).text();
            //console.log(dotsNumber);
            if ($(dotsNumber).length < 2) {
                $(this).html(0 + dotsNumber);
            }
        });

        equalize();

    });

});